import { render, staticRenderFns } from "./Preek.vue?vue&type=template&id=adda0390&scoped=true"
import script from "./Preek.vue?vue&type=script&lang=js"
export * from "./Preek.vue?vue&type=script&lang=js"
import style0 from "./Preek.vue?vue&type=style&index=0&id=adda0390&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adda0390",
  null
  
)

export default component.exports